<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">产品</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">域名转入</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div v-show="activeNames === 'index'" class="se-panel-title">域名转入</div>
        <div v-show="activeNames === 'zhuanru'">
          <el-button plain icon="el-icon-arrow-left" @click="activeNames = 'index'"></el-button>
          <span class="se-panel-title z-padding-left-5-precent ver-sub">域名转入</span>
        </div>
      </div>
      <div class="panel-body">
        <div v-show="activeNames === 'index'">
          <div class="alert-warn">
            1、转入域名时如提示“注册商转移保护”，请联系域名现所在注册商对域名进行解锁
            <br>
            2、国际域名转入请确认距最后一次续费已满60天，否则有可能会出现转入成功续费掉年的现象
            <br>
            3、如域名的转移码中含有空格，请尝试用“+”号替换空格后再进行转入操作
            <br>
            4、如提示转移密码错误，请确认转移密码，并取消本次转移后重新转入
            <br>
            5、申请转移以后，请留意接收确认邮件，及时确认；接收邮箱地址为WHOIS所有人邮箱地址
            <br>
            6、整个转入过程需要5-10个工作日，请您留意转入状态，转入成功或不成功都请您及时联系我们的QQ在线客服进行后续操作
          </div>
          <div class="ub-box z-margin-bottom-20-precent">
            <el-button type="primary" size="mini" icon="el-icon-plus" @click="activeNames = 'zhuanru'">转入</el-button>
          </div>
          <el-table :data="zhuanruList" highlight-current-row show-header v-loading="listLoading" style="width: 100%;">
            <el-table-column prop="domainname" label="域名" width="350" align="left">
            </el-table-column>
            <el-table-column prop="set_time" label="添加时间" align="left" >
            </el-table-column>
            <el-table-column prop="tname" label="模板名称"  align="left">
            </el-table-column>
            <el-table-column prop="state" label="状态"  align="left">
            </el-table-column>
          </el-table>
        </div>
        <div v-show="activeNames === 'zhuanru'">
          <el-form :model="zhuanruForm" ref="zhuanruForm" :rules="rules" label-width="200px" class="domain-form">
            <el-form-item label="域名：" prop="domain">
              <el-input v-model="zhuanruForm.domain" placeholder="输入域名"></el-input>
            </el-form-item>
            <el-form-item label="账户余额：">
              <span class="z-color-red z-font-size-14">{{zhuanruForm.money}}</span>元
              <router-link to="caiwu" class="z-font-size-14 z-color-a">[立即充值]</router-link>
            </el-form-item>
            <el-form-item label="转入费用（自动续费一年）：">
              <span class="z-color-red z-font-size-14">{{zhuanruForm.price}}</span>元
            </el-form-item>
            <el-form-item label="转入联系人模板：" prop="address">
              <el-select v-model="zhuanruForm.mod" placeholder="请选择模板">
                <el-option
                  v-for="item in zhuanruForm.modlist"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <br>
              <span class="z-font-size-12 z-color-333">联系人模板需先通过实名认证</span>
              <router-link to="domainMod" style="color:#333;margin-left: 10px;">【管理模板】</router-link>
            </el-form-item>
            <el-form-item label="转移密码：">
              <el-input v-model="zhuanruForm.password"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" @click="submitForm('zhuanruForm')">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import Xtable from 'components/commons/Xtable.vue'
  import domainService from 'business/domainService.js'
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        domainList:[],
        listLoading:false,
        activeNames:'index',
        input:'',
        zhuanruList: [],
        search:'',
        select:'',
        state:[
          { text: '转入成功', value: '转入成功' },
          { text: '转入失败', value: '转入失败' },
          { text: '转入取消', value: '转入取消' },
          { text: '转入中', value: '转入中' }
        ],
        zhuanruForm:{
          domain:'',
          money:'',
          price:'0',
          mod:'',
          modlist:[],
          password:''
        },
        count:10,
        page:1,
        rules: {
          domain: [
            { validator: async(rule, value, callback) => {
                let data = 'cmd=transfer_check'+'&domainname='+value
                let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
                if(vueData.response == 200){
                  this.zhuanruForm.domain = vueData.domainname
                  this.zhuanruForm.price = vueData.renew_price
                  callback()
                }else{
                  callback(new Error(vueData.msg))
                }
              },trigger: 'blur'}
          ]
        }
      }
    },
    components:{
      Xtable,
      XdialogLoading
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.transferList()
      this.getmoney()
      this.SearchMod()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit()
          } else {
            return false;
          }
        });
      },
      async transferList() {
        let data = 'cmd=transfer_list' +
          '&count='+ this.count +
          '&page='+ this.page
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.zhuanruList = vueData.msg
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async getmoney() {
        let {vueData, state} = await userService.transformToVue('userInfo','POST','cmd=userinfo')
        if(vueData.response == 200 ) {
          this.zhuanruForm.money = vueData.msg.money
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async SearchMod() {
        let data = 'cmd=mod_list'+
          '&count=100'
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.zhuanruForm.modlist = vueData.data.content.map((item, index) => {
            return {
              label:item.tname,
              value:item.id,
            }
          })
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async submit() {
        this.dialogLoading = true
        let data = 'cmd=transfer_add'+
          '&domainname='+ this.zhuanruForm.domain +
          '&renew_price='+ this.zhuanruForm.price +
          '&password='+ this.zhuanruForm.password +
          '&mod_id='+ this.zhuanruForm.mod
        let {vueData, state} = await domainService.transformToVue('domainInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({
            type:'success',
            info: vueData.msg,
            click () {
              self.activeNames = 'index'
              self.transferList()
            }
          })
        }else {
          this.dialogLoading = false
          this.$dialog({
            type:'error',
            info: vueData.msg,
            click () {}
          })
        }
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .domain-form .el-input,.el-select {
    width: 440px;
  }
  .input-with-select .el-input-group__prepend .el-select {
    width: 110px;
  }
  .ver-sub { vertical-align: sub; }
  .alert-warn {
    padding: 7px 22px 5px 50px;
    background: url(../../assets/imgs/tip_icon_warn_16.png) no-repeat 20px 9px #fcecec;
    border: 1px solid #f6b5b5;
    border-radius: 2px;
    color: #e35a55;
    font-size: 12px;
    line-height: 2em;
    margin-bottom: 20px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/product/product7.vue